import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import "./index.css";

// 1. Import the generated route tree
import { routeTree } from "./routeTree.gen";

// 2. Create the router instance
const router = createRouter({
  routeTree,
  // Recommended: preloads data when user hovers over a link
  defaultPreload: "intent",
});

// 3. Register the router for type safety across your whole project
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// 4. Render the application
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
